import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { AnimateAppearanceWrapper } from "../../../../components/animate-appearence/AnimateAppearanceWrapper";
import { PageTitle } from "../../../../components/ui-kit";
import api from "../../../../util/api";
import SupplierDetails from "../components/Details";
import { AppRoutes } from "../../../../constants/routes";
import { isNotFoundApiError } from "../../../../util/apiErrorMessage";
import PageNotFound from "../../../../components/page-not-found";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const SupplierInfo: React.FunctionComponent = () => {
  const { supplierId } = useParams();
  const [supplierDetails, setSupplierDetails] = useState<any>();
  const [notFound, setNotFound] = useState(false);
  const [fatalError, setFatalError] = useState<unknown>(null);
  const navigate = useNavigate();

  useEffect(() => {
    getSupplier(supplierId!);
  }, [supplierId]);
  const getSupplier = async (supplierId: string) => {
    setNotFound(false);
    setFatalError(null);
    try {
      const result = await api.supplierGet(supplierId);
      setSupplierDetails(result);
    } catch (e: unknown) {
      if (isNotFoundApiError(e)) {
        setNotFound(true);
        return;
      }
      setFatalError(e);
    }
  };

  if (fatalError) {
    throw fatalError;
  }

  if (notFound) {
    return <PageNotFound />;
  }

  return (
    <>
      {supplierDetails && (
        <AnimateAppearanceWrapper>
          <Container>
            <TopLine>
              <PageTitle
                onBack={() => {
                  navigate(AppRoutes.Private.Inventory.PRODUCT_LIST);
                }}
                title={`Supplier ${supplierId}`}
                // subtitle="Whole data about your business here"
              />
            </TopLine>
            <SupplierDetails data={supplierDetails} />
          </Container>
        </AnimateAppearanceWrapper>
      )}
    </>
  );
};
